<template>
  <Menu as="div" :class="classes">
    <MenuButton v-if="!iconButton" class="w-full px-1 py-2 mb-2 text-sm font-medium text-left text-gray-700 rounded-md group">
      <component :is="icon" v-if="icon" class="w-5 h-5 mt-1 mr-3 -ml-1" aria-hidden="true" />
      {{ name }}
    </MenuButton>
    <MenuButton v-else>
      <component :is="icon" class="w-5 h-5 mt-1 mr-3 -ml-1" aria-hidden="true" />
    </MenuButton>

    <transition
      enter-active-class="transition duration-100 ease-out"
      enter-from-class="transform scale-95 opacity-0"
      enter-to-class="transform scale-100 opacity-100"
      leave-active-class="transition duration-75 ease-in"
      leave-from-class="transform scale-100 opacity-100"
      leave-to-class="transform scale-95 opacity-0">
      <MenuItems
        v-if="actions.length"
        class="duration-200 z-20 absolute w-[230px] right-8 -mt-2 mb-6 rounded-md shadow-lg bg-white dark:bg-dark-screen-background ring-1 py-2 ring-blue ring-opacity-5 focus:outline-none">
        <MenuItem
          v-for="action in actions"
          :key="action.name"
          :class="action.disabled ? 'cursor-none' : 'cursor-pointer'"
          class="cursor-pointer py-1 hover:bg-gray-300 dark:hover:bg-dark-box-background"
          :disabled="action.disabled"
          @click="action.action">
          <MenuItem>
            <div class="flex">
              <component :is="action.icon" v-if="action.icon" class="flex-shrink-0 w-4 h-4 my-auto ml-4 mr-3" aria-hidden="true" />
              <div class="text-gray-700 dark:text-dark-body-text">
                {{ action.name }}
              </div>
            </div>
          </MenuItem>
        </MenuItem>
      </MenuItems>
    </transition>
  </Menu>
</template>

<script>
import { Listbox, ListboxButton, ListboxOption, ListboxOptions, Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/vue"
import { Lightbulb } from "lucide-vue-next"
export default {
  components: {
    Menu,
    MenuButton,
    MenuItem,
    MenuItems,
    Listbox,
    ListboxButton,
    ListboxOptions,
    ListboxOption,
    Lightbulb
  },
  props: {
    name: {
      type: String,
      default: "Actions"
    },
    classes: {
      type: String,
      default: "relative inline-block text-left"
    },
    icon: {
      type: [Object, Function],
      default: Lightbulb
    },
    actions: {
      type: Array,
      required: true
    },
    iconButton: {
      type: Boolean,
      required: false
    }
  },
  methods: {}
}
</script>
